import yted, { api_get, api_post, api_delete } from '@lf/api-client/lfApi';

export async function submitCoppaAgeCheck(isUnder13, parentEmail = '', setError) {
    return await api_post('/child/coppa-age-check', {
        is_under_13: isUnder13,
        parent_email: parentEmail,
    }, setError);
}

export async function getCoppaConsentStatus(setError) {
    return await api_get('/child/coppa-consent', null, setError);
}

export async function childSignup(username, password, firstName, gradeLevel) {
    try {
        const response = await yted.post('/child/signup', {
            username,
            password,
            first_name: firstName,
            grade_level: gradeLevel,
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 409) {
            return { error: 'Username already taken' };
        }
        if (error.response && error.response.data) {
            return error.response.data;
        }
        return { error: 'An error occurred' };
    }
}

export async function getParentLinkStatus(setError) {
    return await api_get('/child/parent-link', null, setError);
}

export async function createParentLinkRequest(parentEmail, setError) {
    return await api_post('/child/parent-link', { parent_email: parentEmail }, setError);
}

export async function cancelParentLinkRequest(setError) {
    return await api_delete('/child/parent-link', null, setError);
}
